import { defineTokens } from '@chakra-ui/react';
export const colors = defineTokens.colors({
    black: {
        value: '#42213C',
    },
    white: {
        value: '#ffffff',
    },
    primary: {
        shockingPink: {
            value: '#FF00B7',
        },
        blue: {
            value: '#159DFF',
        },
    },
    secondary: {
        persianBlue: {
            value: '#002BC7',
        },
        orange: {
            value: '#FFB200',
        },
    },
    background: {
        offWhite: {
            value: '#FFFDEE',
        },
        skyBlue: {
            value: '#BBD5FA',
        },
        rose: {
            value: '#FFCCE7',
        },
    },
    text: {
        default: {
            value: '#42213C',
        },
        secondary: {
            value: '#90848E',
        },
    },
    state: {
        success: {
            value: '#0DD4B0',
        },
        successBg: {
            value: '#E7F6F3',
        },
        error: {
            value: '#F2186B',
        },
        errorBg: {
            value: '#F9E7E9',
        },
        warn: {
            value: '#FFB200',
        },
        disabled: {
            value: '#C2B9C0',
        },
        disabledBg: {
            value: '#EFEDEE',
        },
    },
});
